import React from 'react'
import styles from './Footer.module.scss'
import Access from './Access'
import Services from './Services'
import LPFooterUIUX from './LPFooter/UIUX/LPFooter'
import LPFooterUIUXNav from './LPFooter/UIUX/LPFooterNav'
import LPFooterFrontend from './LPFooter/Frontend/LPFooter'
import LPFooterFrontendNav from './LPFooter/Frontend/LPFooterNav'
import LPFooterDesignSystem from './LPFooter/DesingSystem/LPFooter'
import LPFooterDesignSystemNav from './LPFooter/DesingSystem/LPFooterNav/LPFooterNav'
import LPFooterFlamingo from './LPFooter/Flamingo/LPFooter'
import { useRouter } from 'next/router'
import ReactHtmlParser from 'react-html-parser'

const Footer: React.FC = () => {
  const router = useRouter()
  const isDesignSystemLpPage: boolean = new RegExp(/services\/designsystem|lp-designsystem-completed/).test(
    router.pathname,
  )
  const isUIUXLpPage: boolean = new RegExp(/uiuxdesign-lp2|\/lp-ui-contact-completed/).test(router.pathname)
  const isFrontendBackendLpPage: boolean = new RegExp(
    /\/frontend-dev|\/lp-frontend-contact-completed|\/backend-dev|\/lp-backend-contact-completed/,
  ).test(router.pathname)
  const isContactPage: boolean = new RegExp(/\/contact\/?$/).test(router.pathname)
  const isAgreementPage: boolean = new RegExp(/\/agreement/).test(router.pathname)
  const isFlamingoPage: boolean = router.pathname.includes('/services/flamingo')

  const htmlContent = `
  <footer class="prj-footer">
    <div class="c-container">
        <div class="prj-footer__inner">
            <div class="prj-footer__heading">
                <div class="prj-footer__logo">
                    <a href="/" class="prj-footer__logo--link no-icon">
                        <img src="/images/logo/logo_i3design.svg" alt="i3DESIGN" class="c-image__normal">
                    </a>
                </div>
                <div class="prj-footer__sns">
                    <ul class="prj-footer__sns--list">
                        <li class="prj-footer__sns--item">
                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                href="https://x.com/i3design_jp" class="prj-footer__sns--link c-link__sns no-icon"
                                target="_blank">
                                <img src="/images/icons/icon_x.svg" alt="X" class="--icon c-image__normal">
                            </a>
                        </li>
                        <li class="prj-footer__sns--item">
                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                href="https://www.facebook.com/i3DESIGN/"
                                class="prj-footer__sns--link c-link__sns no-icon" target="_blank">
                                <img src="/images/icons/icon_facebook.svg" alt="facebook" class="--icon c-image__normal">
                            </a>
                        </li>
                        <li class="prj-footer__sns--item">
                            <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                href="https://www.wantedly.com/companies/i3design"
                                class="prj-footer__sns--link c-link__sns no-icon" target="_blank">
                                <img src="/images/icons/icon_wantedly.svg" alt="Wantedly" class="--icon c-image__normal">
                            </a>
                        </li>
                    </ul>
                    <div class="prj-footer__sns--teams">
                        <ul class="prj-footer__sns--teams--list">
                            <li class="prj-footer__sns--teams--item">
                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                    href="https://tech.i3design.jp/"
                                    class="prj-footer__sns--teams--link c-link__team no-icon" target="_blank">
                                    <img src="/images/img/icon-engineer-team.svg"
                                        alt="エンジニアチーム i3DESIGN Tech Blog" class="c-image__normal">
                                </a>
                            </li>
                            <li class="prj-footer__sns--teams--item">
                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                    href="https://note.com/i3design_design/"
                                    class="prj-footer__sns--teams--link c-link__team no-icon" target="_blank">
                                    <img src="/images/img/icon-designer-team.svg" alt="デザインチーム note" class="c-image__normal">
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <span class="prj-footer__line"></span>
            <nav class="c-display__block--md prj-footer__nav">
                <div class="prj-footer__nav--list">
                    <div class="prj-footer__nav--item --lg">
                        <!-- <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                            href="/services" class="prj-footer__nav--link c-link__main">
                            <p class="--text prj-footer__nav--text font-upgrade">Services</p>
                        </a> -->
                        <p class="--text prj-footer__nav--text font-upgrade">Services</p>

                        <div class="prj-footer__nav--children">
                            <ul class="prj-footer__nav--children--list">
                                <li class="prj-footer__nav--children--item">
                                    <!-- <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                        href="/services#modern-application-development"
                                        class="prj-footer__nav--children--link c-link__main">
                                        <p class="--text prj-footer__nav--children--title">モダナイゼーション</p>
                                    </a> -->
                                    <p class="--text prj-footer__nav--children--title">モダナイゼーション</p>
                                    <div class="prj-footer__nav--children--nav">
                                        <ul class="prj-footer__nav--children--nav--list">
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/application-development"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">アプリケーション開発
                                                    </p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/dev-modernize"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">開発モダナイズ支援
                                                    </p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/devops"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">DevOps構築</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/cloudnative"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">クラウドネイティブ
                                                    </p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="prj-footer__nav--children--item">
                                    <p class="--text prj-footer__nav--children--title">デジタルプロダクトデザイン</p>
                                    <div class="prj-footer__nav--children--nav">
                                        <ul class="prj-footer__nav--children--nav--list">
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/uiuxdesign"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">UI/UXデザイン</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/design-system"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">
                                                        デザインシステム構築</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/frontend-dev"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline"
                                                    target="_blank">
                                                    <p class="--text prj-footer__nav--children--nav--text">フロントエンド開発
                                                    </p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                            <ul class="prj-footer__nav--children--list">
                                <li class="prj-footer__nav--children--item">
                                    <p class="--text prj-footer__nav--children--title">プロダクト成長支援</p>
                                    <div class="prj-footer__nav--children--nav">
                                        <ul class="prj-footer__nav--children--nav--list">
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/strategy"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">事業戦略策定</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/pdm-pmm"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                    <p class="--text prj-footer__nav--children--nav--text">PdM/PMM体制実行支援</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="prj-footer__nav--children--item">
                                    <p class="--text prj-footer__nav--children--title">製品・サービス</p>
                                    <div class="prj-footer__nav--children--nav">
                                        <ul class="prj-footer__nav--children--nav--list">
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="https://eland.jp/"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline"
                                                    target="_blank">
                                                    <p class="--text prj-footer__nav--children--nav--text">ELAND</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                            <li class="prj-footer__nav--children--nav--item">
                                                <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                    href="/services/flamingo"
                                                    class="prj-footer__nav--children--nav--link c-link__footer--inline"
                                                    target="_blank">
                                                    <p class="--text prj-footer__nav--children--nav--text">flamingo</p>
                                                </a>
                                                <!--
                                                                            -->
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="prj-footer__nav--container">
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/cases" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Case study</p>
                            </a>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/about" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">About</p>
                            </a>
                            <div class="prj-footer__nav--children">
                                <ul class="prj-footer__nav--children--list">
                                    <li class="prj-footer__nav--children--item">
                                        <div class="prj-footer__nav--children--nav">
                                            <ul class="prj-footer__nav--children--nav--list">
                                                <li class="prj-footer__nav--children--nav--item">
                                                    <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                        href="/mvv"
                                                        class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                        <p class="--text prj-footer__nav--children--nav--text">当社が目指しているもの</p>
                                                    </a>
                                                    <!--
                                                                            -->
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/news/page/1" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Topics</p>
                            </a>
                            <div class="prj-footer__nav--children">
                                <ul class="prj-footer__nav--children--list">
                                    <li class="prj-footer__nav--children--item">
                                        <div class="prj-footer__nav--children--nav">
                                            <ul class="prj-footer__nav--children--nav--list">
                                                <li class="prj-footer__nav--children--nav--item">
                                                    <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                        href="/news/page/1"
                                                        class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                        <p class="--text prj-footer__nav--children--nav--text">News</p>
                                                    </a>
                                                    <!--
                                                                            -->
                                                </li>
                                                <li class="prj-footer__nav--children--nav--item">
                                                    <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                        href="/pressrelease/page/1"
                                                        class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                        <p class="--text prj-footer__nav--children--nav--text">Press
                                                            release</p>
                                                    </a>
                                                    <!--
                                                                            -->
                                                </li>
                                                <li class="prj-footer__nav--children--nav--item">
                                                    <a data-js-hover="" data-enter-time="400" data-leave-time="600"
                                                        href="/events/page/1"
                                                        class="prj-footer__nav--children--nav--link c-link__footer--inline">
                                                        <p class="--text prj-footer__nav--children--nav--text">
                                                            Event/Seminer</p>
                                                    </a>
                                                    <!--
                                                                            -->
                                                </li>
                                            </ul>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600" href="/in-pocket"
                                class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Blog</p>
                            </a>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/recruit" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Recruit</p>
                            </a>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/contact" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Contact</p>
                            </a>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/download" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Download</p>
                            </a>
                        </div>
                        <div class="prj-footer__nav--item ">
                            <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                href="/mailmagazine" class="prj-footer__nav--link c-link__main">
                                <p class="--text prj-footer__nav--text font-upgrade">Mail magazine</p>
                            </a>
                        </div>
                    </div>
                </div>
            </nav>

            <div class="c-display__hidden--md prj-footer__nav">

                <nav class="c-site-menu --footer">
                    <ul class="c-site-menu__list">
                        <li class="--item c-site-menu__item" style="--delay: 50ms;">
                            <div data-js-accordion="" class="c-site-menu__item--inner">
                                <button type="button" class="c-site-menu__button c-effect__accordion">
                                    <p class="c-site-menu__text font-upgrade">Services</p>
                                    <div class="--icon c-icon__accordion"></div>
                                </button>
                                <div data-js-accordion-target="" class="c-site-menu__children" style="height: 0px;">
                                    <div class="c-site-menu__children--inner">
                                        <!-- <div class="c-site-menu__heading">
                                            <a href="/services"
                                                class="c-site-menu__children--link">
                                                <p class="--text c-site-menu__children--text">Services</p>
                                            </a>
                                        </div> -->
                                        <div data-js-accordion="" class="c-site-menu__children--item ">
                                            <button type="button"
                                                class="c-site-menu__button --border c-effect__accordion">
                                                <p class="--text c-site-menu__button--text font-sans">
                                                    モダナイゼーション</p>
                                                <div class="--icon c-icon__accordion"></div>
                                            </button>
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                                style="height: 0px;">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/application-development"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">アプリケーション開発</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/dev-modernize"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">開発モダナイズ支援</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/devops"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">DevOps構築</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/cloudnative"
                                                            class="c-site-menu__children--link --last">
                                                            <p class="--text c-site-menu__children--text">クラウドネイティブ
                                                            </p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div data-js-accordion="" class="c-site-menu__children--item ">
                                            <button type="button"
                                                class="c-site-menu__button --border c-effect__accordion">
                                                <p class="--text c-site-menu__button--text font-sans">デジタルプロダクトデザイン</p>
                                                <div class="--icon c-icon__accordion"></div>
                                            </button>
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                                style="height: 0px;">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/uiuxdesign"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">UI/UXデザイン</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/design-system"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">
                                                                デザインシステム構築</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/frontend-dev"
                                                            class="c-site-menu__children--link --last"
                                                            target="_blank">
                                                            <p class="--text c-site-menu__children--text">フロントエンド開発</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div data-js-accordion="" class="c-site-menu__children--item ">
                                            <button type="button"
                                                class="c-site-menu__button --border c-effect__accordion">
                                                <p class="--text c-site-menu__button--text font-sans">プロダクト成長支援
                                                </p>
                                                <div class="--icon c-icon__accordion"></div>
                                            </button>
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                                style="height: 0px;">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/strategy"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">事業戦略策定</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/pdm-pmm"
                                                            class="c-site-menu__children--link --last">
                                                            <p class="--text c-site-menu__children--text">PdM/PMM体制実行支援</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div data-js-accordion="" class="c-site-menu__children--item --last">
                                            <button type="button"
                                                class="c-site-menu__button --border c-effect__accordion">
                                                <p class="--text c-site-menu__button--text font-sans">製品・サービス</p>
                                                <div class="--icon c-icon__accordion"></div>
                                            </button>
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav"
                                                style="height: 0px;">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="https://eland.jp/"
                                                            class="c-site-menu__children--link "
                                                            target="_blank">
                                                            <p class="--text c-site-menu__children--text">ELAND</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/services/flamingo"
                                                            class="c-site-menu__children--link --last"
                                                            target="_blank">
                                                            <p class="--text c-site-menu__children--text">flamingo</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 100ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/cases" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Case study</p>
                                </a>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 150ms;">
                            <div data-js-accordion="" class="c-site-menu__item--inner">
                                <button type="button" class="c-site-menu__button c-effect__accordion">
                                    <p class="c-site-menu__text font-upgrade">About</p>
                                    <div class="--icon c-icon__accordion"></div>
                                </button>
                                <div data-js-accordion-target="" class="c-site-menu__children --single"
                                    style="height: 0px;">
                                    <div class="c-site-menu__children--inner">
                                        <div class="c-site-menu__children--item --last">
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/about"
                                                            class="c-site-menu__children--link">
                                                            <p class="--text c-site-menu__children--text">About
                                                            </p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/mvv"
                                                            class="c-site-menu__children--link --last">
                                                            <p class="--text c-site-menu__children--text">当社が目指しているもの</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 200ms;">
                            <div data-js-accordion="" class="c-site-menu__item--inner">
                                <button type="button" class="c-site-menu__button c-effect__accordion">
                                    <p class="c-site-menu__text font-upgrade">Topics</p>
                                    <div class="--icon c-icon__accordion"></div>
                                </button>
                                <div data-js-accordion-target="" class="c-site-menu__children --single"
                                    style="height: 0px;">
                                    <div class="c-site-menu__children--inner">
                                        <div class="c-site-menu__children--item --last">
                                            <div data-js-accordion-target="" class="c-site-menu__children--nav">
                                                <div class="c-site-menu__children--list">
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/news/page/1"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">News</p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/pressrelease/page/1"
                                                            class="c-site-menu__children--link ">
                                                            <p class="--text c-site-menu__children--text">Press release
                                                            </p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                    <div class="c-site-menu__children--item">
                                                        <a href="/events/page/1"
                                                            class="c-site-menu__children--link --last">
                                                            <p class="--text c-site-menu__children--text">Event/Seminer
                                                            </p>
                                                        </a>
                                                        <!--
                                                                -->
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 250ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/in-pocket" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Blog</p>
                                </a>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 300ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/recruit" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Recruit</p>
                                </a>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 350ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/contact" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Contact</p>
                                </a>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 400ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/download" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Download</p>
                                </a>
                            </div>
                        </li>
                        <li class="--item c-site-menu__item" style="--delay: 450ms;">
                            <div class="c-site-menu__item--inner">
                                <a href="/mailmagazine" class="c-site-menu__link">
                                    <p class="--text c-site-menu__text font-upgrade">Mail magazine</p>
                                </a>
                            </div>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
        <div class="prj-footer__footer">
            <div class="prj-footer__footer--inner">
                <div class="prj-footer__footer--technology">
                    <ul class="prj-footer__footer--technology--list">
                        <li class="prj-footer__footer--technology--item">
                            <img src="/images/icons/footer-gitlab.png" alt="GitLab Open Partner" class="c-image__normal">
                        </li>
                        <li class="prj-footer__footer--technology--item">
                            <img src="/images/icons/footer-aws.svg" alt="aws PARTNER" class="c-image__normal">
                        </li>
                    </ul>
                </div>
                <div class="prj-footer__footer--copyright">
                    <nav class="prj-footer__footer--copyright--nav">
                        <ul class="prj-footer__footer--copyright--nav--list">
                            <li class="prj-footer__footer--copyright--nav--item --last">
                                <a data-js-hover="" data-enter-time="300" data-leave-time="600"
                                    href="/privacy"
                                    class="prj-footer__footer--copyright--nav--link c-link__main--sub">
                                    <p class="--text prj-footer__footer--copyright--nav--text">プライバシーポリシー</p>
                                </a>
                            </li>
                        </ul>
                    </nav>
                    <p class="prj-footer__footer--copyright--text font-upgrade">© i3DESIGN Co.,Ltd.</p>
                </div>
            </div>
        </div>
    </div>
  </footer>
  `

  if (isDesignSystemLpPage) {
    return (
      <footer>
        <LPFooterDesignSystemNav />
        <LPFooterDesignSystem />
      </footer>
    )
  }
  if (isUIUXLpPage) {
    return (
      <footer>
        <LPFooterUIUXNav />
        <LPFooterUIUX />
      </footer>
    )
  }
  if (isFrontendBackendLpPage) {
    return (
      <footer>
        <LPFooterFrontendNav />
        <LPFooterFrontend />
      </footer>
    )
  }
  if (isFlamingoPage) {
    return (
      <>
        <LPFooterFlamingo />
        {ReactHtmlParser(htmlContent)}
      </>
    )
  }

  if (isAgreementPage || isContactPage) return <></>
  return (
    //20250124コメントアウト
    //<footer className={styles.footer}>
    //  <div className={styles.group}>
    //    <div className={styles.flex}>
    //      <Access />
    //      <Services />
    //    </div>
    //  </div>
    //</footer>
    <>{ReactHtmlParser(htmlContent)}</>
  )
}

export default Footer
